import KnowioLogo from "../../assets/knowio-logo.png"

import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getGroups, getInactiveSitesAPI, getPagedDevicesAPI, getSiteAnalytics, getBranding } from "../../Api Methods/Api";
import { Await, useNavigate, Link } from "react-router-dom";
import DevicesList from "../../components/GridList/DevicesList";
import DataManager from "../../hooks/DataManager";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import classes from '../OfflineSites/offlineSites.module.css'
import statClasses from '../Dashboard/Dashboard.module.css';
import StatCard from "../../components/UI/Stats/StatCard";
import SearchBar from "../SearchView/Search/SearchBar";
import { filter } from "rxjs";
import ActiveSitesSearchbar from "../ActiveSites/activeSitesSearchbar";
import mixpanel from "mixpanel-browser";
import { Doughnut } from "react-chartjs-2";
import { Dialog } from 'primereact/dialog';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from "chart.js";
import DatePickerModal from "../../components/sub-components/Logs/DatePickerModal";
import { Col, DateRangePicker } from "rsuite";
import { GsSkeletonMainTableCard, SkeletonChart } from "../HolidayMode/scheduledActions";
import { Button } from "primereact/button";
import { logoMap } from "../../helpers/GroupLogoMap";
import { jsPDF } from 'jspdf';
import { format } from "date-fns";
import autoTable from 'jspdf-autotable';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

const centerTextPlugin = {
  id: "centerText",
  beforeDraw(chart) {
      const cfg = chart.config.options.plugins.centerText;
      if (!cfg?.show) return;
      const { ctx, chartArea } = chart;
      const cx = (chartArea.left + chartArea.right) / 2;
      const cy = (chartArea.top + chartArea.bottom) / 2;
      ctx.save();
      ctx.font = `600 16px -apple-system, BlinkMacSystemFont, sans-serif`;
      ctx.fillStyle = "#5c5c5c";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(cfg.text, cx, cy);
      ctx.restore();
  },
};
ChartJS.register(centerTextPlugin);

const makeOptions = (centerText) => ({
    responsive: true,
    maintainAspectRatio: false,
    cutout: "70%",
    plugins: {
        legend: {
            position: "bottom",
            labels: {
                font: { size: 11 },
                padding: 10,
                boxWidth: 10,
                usePointStyle: true,
                generateLabels: (chart) => {
                    const { labels, datasets } = chart.data;
                    return labels.map((label, i) => ({
                        text: `${label} - ${datasets[0].data[i].toLocaleString()}%`,
                        fillStyle: datasets[0].backgroundColor[i],
                        strokeStyle: datasets[0].backgroundColor[i],
                        pointStyle: "circle",
                        hidden: false,
                        index: i,
                    }));
                },
            },
        },
        tooltip: {
            enabled: true,
            callbacks: {
                label: (context) => `${context.raw.toLocaleString()}%`
            }
        },
        centerText: { show: true, text: centerText },
    },
});

const times = ["7D", "1M", "3M"];

const C = {
    online: "#60e08f",
    offline: "#ee6d6d"
};

const StabilityHeader = ({ title, selectedTime, setSelectedTime, dateRange, setDateRange, handleOK, disableDates, showModal, HandleCloseModal, onSelect, modalTitle, modalComponent, generatePDF }) => (
  <>
    <div>
      <DatePickerModal show={showModal} onClose={HandleCloseModal} title={modalTitle} onSelect={onSelect}>
        {modalComponent}
      </DatePickerModal>
    </div>
    <div className={statClasses.sectionHeaderTime} style={{ marginTop: "12px", marginBottom: "12px"}}>
      <p className={statClasses.sectionTitle}>
        {selectedTime === "7D" ? (
          `${title} - Last 7 days`
        ) : selectedTime === "1M" ? (
          `${title} - Last 30 days`
        ) : selectedTime === "3M" ? (
          `${title} - Last 90 days`
        ) : (
          title
        )}
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'flex-end'}}>
        <div className={statClasses.timeDropdown} style={{ justifyContent: 'flex-end'}}>
          <DateRangePicker style={{
            display: "flex",
            border: "1px solid #00000099",
            borderRadius: "8px",
            height: "30px",
            maxWidth: "50%"
          }}
            placement="bottomEnd"
            format="yyyy.MM.dd"
            onChange={handleOK} // pass in
            shouldDisableDate={disableDates} // pass in
            calendarSnapping={true}
            appearance="subtle"
            onClean={() => {
              setDateRange(null)
              setSelectedTime("7D")
            }}
            cleanable={true}
            ranges={[]}
            value={dateRange ? [new Date(dateRange[0]), new Date(dateRange[1])] : null}
          />
          {times.map((time) => (
            <button
                key={time}
                className={selectedTime === time ? statClasses.timeButtonActive : statClasses.timeButton}
                onClick={() => {
                  setSelectedTime(time)
                  setDateRange(null)
                }}
                
            >
                {time}
            </button>
          ))}
        </div>
        <Button
          label="Export PDF"
          icon="pi pi-file-pdf"
          style={{
              height: "28px",
              fontSize: "14px",
              padding: "6px 10px",
              lineHeight: "1",
              width: '125px'
          }}
          onClick={generatePDF}
        />
      </div>
    </div>
  </>
);

const DonutCard = ({ title, labels, values, colours, centerText, isLoadingStability, donutChartRef }) => {
  const total = values.reduce((a, b) => a + b, 0);
  const hasData = total > 0;
  const data = {
      labels,
      datasets: [{ data: values, backgroundColor: colours, borderWidth: 0, hoverOffset: 4 }],
  };
  const displayText = centerText !== undefined ? centerText : total.toLocaleString();
  return (
    <div className={statClasses.chartCard}>
      <p className={statClasses.chartTitle}>{title}</p>
      {isLoadingStability ? (
        <div style={{ height: "215px", width: "300px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <div className={classes.skeletonCircle} />
          <div className={statClasses.skeletonBar} style={{ height: "10px", width: "65%", marginTop: "14px" }} />
        </div>
      ) : !hasData ? (
        <div style={{ height: "215px", width: "300px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <p style={{ textAlign: "center", color: "#888888" }}>No data available</p>
        </div>
      ) : (
        <div className={statClasses.donutContainer} style={{ height: "215px"}}>
          <Doughnut ref={donutChartRef} data={data} options={makeOptions(displayText)}/>
        </div>
      )}
    </div>
  )
};

const StatCardsGrid = ({ statusCards, reportCards }) => (
   <div style={{ width: "100%" }}>
    <p className={statClasses.chartTitle}>Reporting Coverage</p>
    <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center", gap: "12px"}}>
      {reportCards.map((card, i) => (
        <div key={i} style={{ flex: 1 }}>
          <StatCard title={card.title} value={card.value} hasLabel={true} label={card.label} isLoading={card.isLoadingStability} onClick={card.onClick} />
        </div>
      ))}
    </div>

  <br />
  <br />

    <p className={statClasses.chartTitle}>Last Reported Status</p>
    <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center", gap: "12px"}}>
      {statusCards.map((card, i) => (
        <div key={i} style={{ flex: 1 }}>
          <StatCard title={card.title} value={card.value} hasLabel={true} label={card.label} isLoading={card.isLoadingStability} />
        </div>
      ))}
    </div>
</div>
);

const StabilityAnalyticsRow = ({ donutProps, cardProps, reportCardProps }) => (
  <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center", gap: "12px"}}>
    <DonutCard {...donutProps} />
    <StatCardsGrid {...cardProps} {...reportCardProps} />
  </div>
);

const IonTable = ({ data, isLoadingStability, HandleUipiodOnClick }) => (
  <div className={statClasses.chartCard}>
    <p className={statClasses.chartTitle}>Overview</p>
    { isLoadingStability ? (
      <GsSkeletonMainTableCard />
    ) : (
        <DataTable value={data} paginator showGridlines={true} rows={20} rowsPerPageOptions={[20, 30, 40, 50, 100]} removableSort emptyMessage="No data available">
          <Column 
            field="key" 
            header="Site ID"
            style={{ minWidth: "8rem" }}
            body={(rowData) => (
              <Link
                onClick={HandleUipiodOnClick}
                className={classes.tableUser}
                to={`/Dashboard/SiteView/${rowData.UUID}`}
              >
                {rowData.key}
              </Link>
            )}
            />
          <Column field="tag" header="Name" style={{ minWidth: "12rem" }} body={(rowData) => rowData.tag || "[No Name Set]"} />
          <Column
            field="online_count"
            header="Uptime"
            sortable
            sortFunction={(e) => [...e.data].sort((a, b) => {
              const valA = calculateStability(a.online_count, a.offline_count);
              const valB = calculateStability(b.online_count, b.offline_count);
              return e.order * ((valA === 'N/A' ? -1 : valA) - (valB === 'N/A' ? -1 : valB));
            })}
            style={{ minWidth: "6rem" }}
            body={(rowData) => `${calculateStability(rowData.online_count, rowData.offline_count)}%`}
          />
          <Column field="offline_count" header="Disconnections" sortable style={{ minWidth: "6rem" }} body={(rowData) => rowData.offline_count} />
          <Column 
            field="current_status" 
            header="Status" 
            style={{ minWidth: "10rem" }} 
            sortable
            body={(rowData) => (
              <span>
                {rowData.current_status === "YES" ? "Online" : "Offline"}
              </span>
            )}
          />
          <Column 
            field="offlineSince" 
            header="Offline Since" 
            style={{ minWidth: "8rem" }}
            sortable 
            body={(rowData) => (
              <span>
                {rowData.current_status === "NO" ? formatEventDate(rowData.offlineSince, "standard") : "N/A"}
              </span>
            )}
          />
        </DataTable>
      )}
  </div>

);

const NoStatusDialog = ({ showNoStatusDialog, setShowNoStatusDialog, noStatusList, HandleUipiodOnClick }) => (
    <Dialog
      header="Non-reporting iONs"
      visible={showNoStatusDialog}
      style={{ width: '75vw' }}
      onHide={() => setShowNoStatusDialog(false)}
    >
      <DataTable
        value={noStatusList}
        paginator
        rows={20}
        rowsPerPageOptions={[20, 30, 40, 50, 100]}
        showGridlines
        emptyMessage="No data available"
        removableSort
        filterDisplay="row"
      >
        <Column 
          field="key"
          header="Site ID"
          body={(rowData) => (
            <Link
              onClick={HandleUipiodOnClick}
              className={classes.tableUser}
              to={`/Dashboard/SiteView/${rowData.UUID}`}
            >
              {rowData.key}
            </Link>
          )} />
        <Column field="tag" header="Name" style={{ minWidth: "12rem" }} filter filterPlaceholder="Search name..." filterMatchMode="contains" body={(rowData) => rowData.tag || "[No Name Set]"} />
        <Column
          field="current_status"
          header="Status"
          style={{ minWidth: "10rem" }}
          sortable
          body={(rowData) => (
            <span>
              {rowData.current_status === "YES" ? "Online" : "Offline"}
            </span>
          )}
          />
        <Column 
          field="offlineSince" 
          header="Offline Since" 
          style={{ minWidth: "8rem" }} 
          sortable
          body={(rowData) => (
            <span>
              {rowData.current_status === "NO" ? formatEventDate(rowData.offlineSince, "standard") : "N/A"}
            </span>
          )}
        />
      </DataTable>
    </Dialog>
);

const getStabilityStats = (stabilityData) => {
  if (!stabilityData || stabilityData.length === 0) return { total: 0, online_ions: 0, offline_ions: 0, total_online_count: 0, total_offline_count: 0, uptimeRate: 0, downtimeRate: 0 };

  const total = stabilityData.length;
  const online_ions = stabilityData.filter((site) => site.current_status === "YES");
  const offline_ions = stabilityData.filter((site) => site.current_status === "NO");

  const total_online_count = online_ions.reduce((sum, site) => sum + site.online_count, 0);
  const total_offline_count = offline_ions.reduce((sum, site) => sum + site.offline_count, 0);

  const uptimeRate = total_online_count + total_offline_count === 0 ? 0 : parseFloat((total_online_count / (total_online_count + total_offline_count) * 100).toFixed(1));
  const downtimeRate = total_online_count + total_offline_count === 0 ? 0 : parseFloat((total_offline_count / (total_online_count + total_offline_count) * 100).toFixed(1));

  return { total, online_ions: online_ions.length, offline_ions: offline_ions.length, total_online_count, total_offline_count, uptimeRate, downtimeRate };

}

const calculateStability = (online, offline) => {
  if ((online === null || online === 0 || !online) && (offline === null || offline === 0 || !offline)) { return 'N/A' }
  const total = online + offline;
  const stabilityRate = total === 0 ? 0 : parseFloat((online / total * 100).toFixed(1));
  return stabilityRate;
};

const getNoPingedIONS = (allIons, pingedIons) => {
  if (!allIons || allIons.length === 0) {
    return { noPingedIons: [], noPingedCount: 0 };
  }
  const pingedKeys = new Set((pingedIons || []).map(ion => ion.key));
  const noPingedIons = allIons.filter(ion => !pingedKeys.has(ion.key));
  return { noPingedIons, noPingedCount: noPingedIons.length };
};

const formatEventDate = (dateStr, period) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return dateStr;
  

  switch (period) {
  case '7D':
      return date.toLocaleDateString('en-US', { weekday: 'short' });
  case '1M':
      return `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  case '3M':
      return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit' });
  case 'standard':
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  default:
      return dateStr;
  }
};


const Controllers = () => {

  const savedState = JSON.parse(sessionStorage.getItem('ionAnalyticsState') || 'null');
  const [controllers, setControllers] = useState([]);

  //const [activeSites, setActiveSites] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingStats, setIsLoadingStats] = useState(true)
  const [searchTerm, setSearchTerm] = useState("")
  const [filteredData, setFilteredData] = useState([])
  const dataManager = new DataManager();

  const [totalPages, setTotalPages] = useState([])
  const [resultCount, setResultCount] = useState(0)
  const [onlineCount, setOnlineCount] = useState(0)
  const [offlineCount, setOfflineCount] = useState(0)
  const [noUserCount, setNoUserCount] = useState(0)


  const [totalDevices, setTotalDevices] = useState([])
  const [pageOffset, setPageOffset] = useState(0)
  const dispatch = useDispatch();
  const client = useSelector(state => state.auth.client);
  const token = useSelector(state => state.auth.token);
  const companyName = useSelector(state => state.auth.companyName);
  const [pageFetchedIndex, setPageFetchedIndex] = useState(1)
  const [pageSize, setPageSize] = useState(dataManager.getItem('pageSize'))
  const [update, setUpdate] = useState(0)
  const [showMassSettings, setShowMassSettings] = useState(false)

  const [selectedFilter, setSelectedFilter] = useState("")
  const [sortBy, setSortBy] = useState([])
  const [page, setPage] = useState(1);
  const [visibleDevices, setVisibleDevices] = useState([]);
  
  const [groups, setGroups] = useState([])
  const [selectedGroupFilter, setSelectedGroupFilter] = useState([])
  const [portalSiteNameFilter, setPortalSiteNameFilter] = useState("")
  const [includes, setIncludes] = useState(true)

  const [activeTab, setActiveTab] = useState(savedState ? savedState.activeTab : 0)
  const [online, setOnline] = useState(0)
  const [offline, setOffline] = useState(0)
  const [deviceTag, setDeviceTag] = useState(null)
  const [deviceType, setDeviceType] = useState(1)
  const [groupName, setGroupName] = useState(null)
  const [noTag, setNoTag] = useState(0)
  const [stabilityData, setStabilityData] = useState([]);
  const [ionlist, setIonList] = useState([]);
  const [isLoadingStability, setIsLoadingStability] = useState(true);
  const [showNoStatusDialog, setShowNoStatusDialog] = useState(false);
  const [brandingName, setBrandingName] = useState("");

  const [selectedTime, setSelectedTime] = useState(savedState ? savedState.selectedTime : "7D");
  const [dateRange, setDateRange] = useState(savedState ? savedState.dateRange : null);
  const [modalComponent, setModalComponent] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("Select a date range to view");
  const donutChartRef = useRef(null);

  const [submit, setSubmit] = useState(0)

  const [showLoadMore, setShowLoadMore] = useState(true)

  const prevBody = useRef();
  const apiDataRef = useRef({ token, client, companyName });
  apiDataRef.current = { token, client, companyName };
  const apiData = {
      token,
      client
  }

  const now = new Date();
  const last7 = new Date();
  last7.setDate(now.getDate() - 7);
  const last30 = new Date();
  last30.setDate(now.getDate() - 30);
  const last90 = new Date();
  last90.setDate(now.getDate() - 90);
  const sixMonthsAgo = new Date();
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
  
  const logo = logoMap[brandingName] || KnowioLogo

  const getSites = async (body) => {
      const response = await getInactiveSitesAPI(apiData, body, dispatch)
      setControllers(response.data[1])
      setResultCount(response.data[0][0].totalCount)
      setOnlineCount(response.data[0][0].onlineControllers)
      setOfflineCount(response.data[0][0].offlineControllers)
      setNoUserCount(response.data[0][0].noUserControllers)
      setFilteredData(response.data[1])
      setTotalPages(Math.ceil(response.data[0][0].totalCount / pageSize));
      setIsLoading(false)
      setIsLoadingStats(false)
  }

  const GetGroups = async () => {
      try {
          const listOptions = await getGroups(apiData, dispatch);
          setGroups(listOptions || []);
      } catch (error) {
          console.error('Failed to fetch groups:', error);
          setGroups([]);
      }
  }

  const HandleUipiodOnClick = () => {
    sessionStorage.setItem('ionAnalyticsState', JSON.stringify({
      activeTab,
      dateRange,
      selectedTime
    }))
  }

  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}T12:00:00.000Z`;
  };

  const handleOK = (value) => {
    if (value) {
        setDateRange([formatLocalDate(value[0]), formatLocalDate(value[1])]);
        setSelectedTime(null)
    } else {
        setDateRange(null);
    }
  };

  const disableDates = (date) => {
    return date < sixMonthsAgo || date > now;
  };

  const HandleCloseModal = () => {
    setShowModal(false)
  };

  const onSelect = () => {
    HandleCloseModal();
  };

  const generatePDF = () => {
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    const pageW = doc.internal.pageSize.getWidth();
    const margin = 18;

    let startDate, endDate;
    if (selectedTime) {
        endDate = now;
        startDate = selectedTime === "7D" ? last7 : selectedTime === "1M" ? last30 : last90;
    } else if (dateRange) {
        startDate = new Date(dateRange[0]);
        endDate = new Date(dateRange[1]);
    } else {
        startDate = last7;
        endDate = now;
    }
    const dateRangeStr = `${format(startDate, "MMM d, yyyy")} - ${format(endDate, "MMM d, yyyy")}`;

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    const titleText = `${apiDataRef.current.companyName || localStorage.getItem('companyName') || ""} - iON Stability`;
    const titleMaxWidth = pageW - margin * 2 - 25;
    const titleLines = doc.splitTextToSize(titleText, titleMaxWidth);
    const extraTitleHeight = (titleLines.length - 1) * 6;
    const headerHeight = 36 + extraTitleHeight;

    doc.setFillColor(28, 37, 54);
    doc.rect(0, 0, pageW, 32, 'F');

    if (logo) {
        const logoWidth = 17;
        const logoHeight = 17;
        const logoX = pageW - margin - logoWidth;
        const logoY = 4;
        doc.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);
    }

    doc.setTextColor(255, 255, 255);
    doc.text(titleLines, margin, 10);

    let headerY = 10 + (titleLines.length * 2);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(180, 195, 220);
    doc.text(dateRangeStr, margin, headerY + 7);
    doc.text(`Generated: ${format(new Date(), "MMM d, yyyy")}`, margin, headerY + 12);

    const filename = `ion-stability-report-${apiDataRef.current.companyName.toLowerCase() || localStorage.getItem('companyName').toLowerCase() || ""}-${format(new Date(), "yyyy-MM-dd")}.pdf`;

    let curY = headerHeight + 8;

    doc.setTextColor(30, 30, 30);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.text('Summary Statistics', margin, curY);
    curY += 10;

    const statItems = [
      { label: 'Total iONs Reported', value: `${getStabilityStats(stabilityData).total || 0}` || 'N/A' },
      { label: 'Total iONs With No Status Update', value: `${getNoPingedIONS(ionlist, stabilityData).noPingedCount || 0}` || 'N/A'},
      { label: 'Online iONs', value: `${getStabilityStats(stabilityData).online_ions || 0}` || 'N/A' },
      { label: 'Offline iONs', value: `${getStabilityStats(stabilityData).offline_ions || 0}` || 'N/A' }
    ]

    doc.setFontSize(9);
    const colWidth = (pageW - margin * 2) / 2;
    statItems.forEach((item, i) => {
        const col = i % 2;
        const row = Math.floor(i / 2);
        const x = margin + col * colWidth;
        const y = curY + row * 12;

        doc.setFont('helvetica', 'normal');
        doc.setTextColor(100, 100, 100);
        doc.text(item.label + ':', x, y);
        const labelWidth = doc.getTextWidth(item.label + ':');
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(30, 30, 30);
        doc.text(String(item.value), x + labelWidth + 5, y);
    });

    curY += Math.ceil(statItems.length / 2) * 12 + 10;

    // divider line 
    doc.setDrawColor(200, 200, 200);
    doc.line(margin, 75, pageW - margin, 75);
    
    curY += 10;

    if (donutChartRef.current) {
      const chart = donutChartRef.current;

      chart.resize(300, 300);
      chart.update('none')

      const chartImage = chart.toBase64Image();

      chart.resize();
      chart.update('none');

      doc.addImage(chartImage, 'PNG', 65, 90, 70, 70);
      curY += 75;
    }

    curY += 5;
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.setTextColor(30, 30, 30);
    doc.text('iON Report Details', margin, curY);
    curY += 6;

    const tableData = stabilityData.map(row => [
      row.key,
      row.tag || '[No Name Set]',
      calculateStability(row.online_count, row.offline_count) === 'N/A' ? 'N/A' : `${calculateStability(row.online_count, row.offline_count)}%`,
      row.offline_count,
      row.current_status === 'YES' ? 'Online' : 'Offline',
      row.current_status === 'NO' ? formatEventDate(row.offlineSince, 'standard') : 'N/A'
    ]);

    autoTable(doc, {
        startY: curY,
        margin: { left: margin, right: margin },
        head: [['Site ID', 'Name', 'Uptime', 'Disconnections', 'Status', 'Integration', 'Offline Since']],
        body: tableData,
        headStyles: { fillColor: [28, 37, 54], textColor: [255, 255, 255], fontSize: 8, fontStyle: 'bold' },
        bodyStyles: { fontSize: 8, textColor: [50, 50, 50] },
        alternateRowStyles: { fillColor: [249, 250, 251] },
        columnStyles: {
            0: { cellWidth: 28 },
            1: { cellWidth: 48 },
            2: { halign: 'center', cellWidth: 16 },
            3: { halign: 'center', cellWidth: 18 },
            4: { halign: 'center', cellWidth: 24 },
            5: { halign: 'center', cellWidth: 24 },
            6: { halign: 'center', cellWidth: 22 },
        },
        styles: { cellPadding: 3 },
    });

    const pageH = doc.internal.pageSize.getHeight();
    doc.setFillColor(28, 37, 54);
    doc.rect(0, pageH - 14, pageW, 14, 'F');
    doc.setTextColor(180, 195, 220);
    doc.setFontSize(7);
    doc.setFont('helvetica', 'normal');
    doc.text('Portal Analytics Report', pageW / 2, pageH - 6, { align: 'center' });
    doc.save(filename);
  }

  const GetBrandingName = async (groupName) => {
    let body = {
        groupName: groupName ?? companyName
    }

    const response = await getBranding(apiData, body, dispatch)
    if (response.success){
        setBrandingName(response.data["emailBranding"])
    }
  }

  useEffect(() => {
    GetBrandingName();
  }, [companyName])

  useEffect(() => {
      if (savedState) {
        sessionStorage.removeItem('ionAnalyticsState');
      }
    }, [])

  useEffect(() => {
    GetGroups();

    mixpanel.track("Controllers tab visited", {
      user: localStorage.getItem('email')
    });

  }, [])

  useEffect(() => {
    setStabilityData([]);
    setIsLoadingStability(true);

    const FetchStabilityData = async () => {
      const response = await getSiteAnalytics(apiDataRef.current, {
        groupName: apiDataRef.current.companyName || localStorage.getItem('companyName'),
        start_date: selectedTime ? (selectedTime === "7D" ? last7 : selectedTime === "1M" ? last30 : last90) : (dateRange ? new Date(dateRange[0]) : last7),
        end_date: selectedTime ? now : dateRange ? new Date(dateRange[1]) : now,
        analyticsType: "ions"
      }, dispatch);

      setStabilityData(response?.data[0].pingedIONs || []);
      setIonList(response?.data[0].allIONs || []);
      setIsLoadingStability(false);
    }

    FetchStabilityData();

  }, [selectedTime, dateRange])

  useEffect(() => {
    setIsLoading(true)
    const offset = pageSize * (pageFetchedIndex -1); 
    setPageOffset(offset);

      let body = {
          "active": -1,
          "pageSize": pageSize,
          "pageOffset": offset,
          "online": online,
          "offline": offline, 
          "deviceTag": deviceTag,
          "deviceType": deviceType,
          "groupName": groupName,
          "noTag": noTag,
          "searchTerm": searchTerm
      }

      getSites(body)

      const timer = setTimeout(() => {
        if (prevBody.current && (JSON.stringify(body) !== JSON.stringify(prevBody.current))) {
            mixpanel.track("Controllers search performed", {
                user: localStorage.getItem('email'),
                body: body
            });
        }
        prevBody.current = body;
      }, 2000);
      return () => clearTimeout(timer);
  }, [submit, pageSize, pageFetchedIndex, online, offline, deviceTag, deviceType, groupName, noTag])

  useEffect(() => {
    const delay = setTimeout(() => {
      // Trigger a refresh via submit or whatever you use
      setSubmit(prev => !prev); 
    }, 400); // 300–500ms debounce recommended
  
    return () => clearTimeout(delay);
  }, [searchTerm]);

  return (
    <>
    
    <div style={{ display: "flex", flexDirection: "row", gap: "12px", marginBottom: "8px", alignContent:"flex-start", alignItems:"flex-start", alignSelf:"start", width:"100%"  }}>
        <StatCard title={"All iON count"} value={resultCount} isLoading={isLoadingStats} />
        <StatCard title={"Online iONs"} value={onlineCount} isLoading={isLoadingStats} />
        <StatCard title={"Offline iON's"} value={offlineCount} isLoading={isLoadingStats} />
        <StatCard title={"iONs with no users"} value={noUserCount} isLoading={isLoadingStats} />
    </div>

        <div className={classes.tabsWrapper}>
          <div className={classes.tabs}>
            {["iONs", "Stability"].map((tab, i) => (
                <button
                    key={tab}
                    className={`${classes.tab} ${activeTab === i ? classes.active : ""}`}
                    onClick={() => setActiveTab(i)}
                >
                    {tab}
                </button>
              ))}
          </div>

          <div className={classes.tabContent}>
            {activeTab === 0 && (
              <>
                <div className={classes.searchContainer}>
                  <ActiveSitesSearchbar
                      type="text"
                      placeholder="Search..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      showFilterButton={true}
                      groups={groups}
                      online={online}
                      setOnline={setOnline}
                      offline={offline}
                      setOffline={setOffline}
                      deviceTag={deviceTag}
                      setDeviceTag={setDeviceTag}
                      deviceType={deviceType}
                      setDeviceType={setDeviceType}
                      groupName={groupName}
                      setGroupName={setGroupName}
                      submit={submit}
                      setSubmit={setSubmit}
                      noTag={noTag}
                      setNoTag={setNoTag}
                      isControllers={true}
                      style={{
                          padding: "10px", 
                          width: "300px",    
                          fontSize: "14px",  
                          boxSizing: "border-box", 
                          borderRadius: "4px",
                      }}/>

                  {searchTerm !== "" && <div>
                      <p>{filteredData.length} results</p>
                  </div>}
                </div>


              <Await resolve={controllers}>
                {(loadedControllers) => {
                  return (
                    <>
                    <div style={{ width: "100%"}}>
                    {isLoading ? (
                      <div style={{ display: "flex", width: "100%" }}>
                        <DeviceLoadingGrid
                          CardCount={
                            20
                          }
                        />
                      </div>
                    ) : (
                      <>
                    
                      <DevicesList
                        devices={loadedControllers}
                        filtering={""}
                        hideControls={false}
                        totalPages={totalPages}
                        setTotalPages={setTotalPages}
                        pageFetchedIndex={pageFetchedIndex}
                        setPageFetchedIndex={setPageFetchedIndex}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        totalDevices={resultCount}
                        setTotalDevices={setTotalDevices}
                        groupMode={false}
                        update={update}
                        setUpdate={setUpdate}
                        offlineOnly={false}
                        isSortable={true}
                        showMassSelect={true}
                        showMassSettings={showMassSettings}
                        setShowMassSettings={setShowMassSettings}
                        
                      />
                      </>
                      
                    )}
                  </div>
                </>
                )
              }}
            </Await>
          </>
          )}

          {activeTab === 1 && (
            <>
            <br />
            <StabilityHeader 
              title="iON Stability" 
              selectedTime={selectedTime} setSelectedTime={setSelectedTime} 
              dateRange={dateRange} setDateRange={setDateRange}
              handleOK={handleOK} disableDates={disableDates}
              showModal={showModal} HandleCloseModal={HandleCloseModal} 
              onSelect={onSelect} modalTitle={modalTitle}
              modalComponent={modalComponent}
              generatePDF={generatePDF}
            />
            <StabilityAnalyticsRow 
                donutProps={{
                  title: "Average Uptime",
                  labels: ["Uptime", "Downtime"],
                  values: [getStabilityStats(stabilityData).uptimeRate, getStabilityStats(stabilityData).downtimeRate],
                  colours: [C.online, C.offline],
                  centerText: `${getStabilityStats(stabilityData).uptimeRate}%`,
                  isLoadingStability: isLoadingStability,
                  donutChartRef: donutChartRef
                }}
                cardProps={{
                  statusCards: [
                    { title: "Online", value: getStabilityStats(stabilityData).online_ions, isLoadingStability: isLoadingStability },
                    { title: "Offline", value: getStabilityStats(stabilityData).offline_ions, isLoadingStability: isLoadingStability }
                  ]
                }}
                reportCardProps={{
                  reportCards: [
                    { title: "Total Reported", value: getStabilityStats(stabilityData).total, label: selectedTime === "7D" ? "Past 7 days" : selectedTime === "1M" ? "Past 30 days" : selectedTime === "3M" ? "Past 90 days" : "", isLoadingStability: isLoadingStability },
                    { title: "No Status Update", value: getNoPingedIONS(ionlist, stabilityData).noPingedCount || 0, label: "Click to view", isLoadingStability: isLoadingStability, onClick: () => setShowNoStatusDialog(true) }
                  ] 
                }}
            />
            <br />
            <IonTable data={stabilityData} isLoadingStability={isLoadingStability} HandleUipiodOnClick={HandleUipiodOnClick} />
            <NoStatusDialog showNoStatusDialog={showNoStatusDialog} setShowNoStatusDialog={setShowNoStatusDialog} noStatusList={getNoPingedIONS(ionlist, stabilityData).noPingedIons} HandleUipiodOnClick={HandleUipiodOnClick} />
            </>
          )}
        </div>
      </div>
      </>
    )
}

  //   const dataManager = new DataManager();
  //   const [sites, setSites] = useState([])
  //   const [offlineSites, setOfflineSites] = useState([])
  //   const [onlineSites, setOnlinesites] = useState([])
  //   const [sitesNoUsers, setsitesNoUsers] = useState([])
  //   const [totalPages, setTotalPages] = useState([])
  //   const [totalDevices, setTotalDevices] = useState([])
  //   const [isLoading, setIsLoading] = useState(true)
  //   const [update, setUpdate] = useState(0)
  //   const navigate = useNavigate();
  //   const dispatch = useDispatch();
  //   const client = useSelector(state => state.auth.client);
  //   const token = useSelector(state => state.auth.token);
  //   const [showMassSettings, setShowMassSettings] = useState(false)
    

  //   const currentDate = new Date();
  //   const oneMonthAgo = new Date();
  //   oneMonthAgo.setMonth(currentDate.getMonth() - 1);

  //   const [searchTerm, setSearchTerm] = useState('');
  //   const [filteredData, setFilteredData] = useState([]); // Track filtered data

  //   const [pageFetchedIndex, setPageFetchedIndex] = useState(1)
  //   const [pageSize, setPageSize] = useState(1000)

  //   const apiData = {
  //       token,
  //       client
  //   }

  //   useEffect(() => {
  //       const getSites = async () => {
  //         const responseData = await getPagedDevicesAPI(apiData, 5000, pageFetchedIndex, 1, 1, 0, 0, dispatch);
  //         const totalDevices = responseData[0].totalDevices["COUNT(*)"];
  //         const data = responseData[0].devices;
      
  //         const allSites = [];
  //         const offlineSites = [];
  //         const onlineSites = [];
  //         const sitesNoUsers = [];
      
  //         data.forEach((device) => {
  //           if (["AB", "ESP", "A"].includes(device.type)) {
  //             allSites.push(device);
  //             if (device.online === "NO") offlineSites.push(device);
  //             if (device.online === "YES") onlineSites.push(device);
  //             if (device.userCount === 0) sitesNoUsers.push(device);
  //           }
  //         });
      
  //         setFilteredData(allSites);
  //         setSites(allSites);
  //         setOfflineSites(offlineSites);
  //         setOnlinesites(onlineSites);
  //         setsitesNoUsers(sitesNoUsers);
      
  //         setTotalPages(Math.ceil(totalDevices / pageSize));
  //         setTotalDevices(totalDevices);
  //         setPageSize(totalDevices);
  //         setIsLoading(false);
  //       };
      
  //       getSites();
  //     }, []);

  //   const applyFilter = (filterData) => {
  //     setFilteredData(filterData); // Update filteredData based on clicked filter
  //   };

  //   useEffect(() => {
  //     const handleDeviceFilter = () => {
  //       const filtered = sites.filter((item) =>
  //         Object.values(item)
  //           .some((value) => value?.toString().toLowerCase().includes(searchTerm.toLowerCase()))
  //       );
  //       dataManager.setItem('controllersSearchTerm', searchTerm); // Store search term
  //       setFilteredData(filtered); // Update filtered data
  //     };
    
  //     if (searchTerm !== dataManager.getItem('controllersSearchTerm')) {
  //       handleDeviceFilter(); // Call filtering function
  //     }
  //   }, [searchTerm, sites]);
    
  //   return (
  //     <Await resolve={sites}>
  //       {(loadedSites) => {
  //         return (
  //           <>
  //           <div style={{ width: "100%"}}>
  //           <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
  //           <div
  //               onClick={() => {
  //                applyFilter(loadedSites); 
  //               }}
  //               style={{ cursor: "pointer", width:"350px"}} 
  //             >
  //             <Stats2
  //               title={"All controller count"}
  //               value={loadedSites.length}
  //               isLoadingStats={isLoading}
  //               isStatic={true}
  //             />
  //           </div>
  //           <div
  //               onClick={() => {
  //                 applyFilter(onlineSites) 
  //               }}
  //               style={{ cursor: "pointer", width:"350px" }} 
  //             >
  //             <Stats2
  //               title={"Online controllers"}
  //               value={onlineSites.length}
  //               isLoadingStats={isLoading}
  //               isStatic={true}
  //             />
  //           </div>
  //           <div
  //               onClick={() => {
  //                 applyFilter(offlineSites) 
  //               }}
  //               style={{ cursor: "pointer", width:"350px" }} 
  //             >
  //             <Stats2
  //               title={"Offline controllers "}
  //               value={offlineSites.length}
  //               isLoadingStats={isLoading}
  //               isStatic={true}
  //             />
  //           </div>
  //           <div
  //               onClick={() => {
  //                 applyFilter(sitesNoUsers) 
  //               }}
  //               style={{ cursor: "pointer", width:"350px" }} 
  //             >
  //             <Stats2
  //               title={"Controllers with no users"}
  //               value={sitesNoUsers.length}
  //               isLoadingStats={isLoading}
  //               isStatic={true}
  //             />
  //           </div>
  //         </div>

  //           <br></br>
  //           {isLoading ? (
  //             <div style={{ display: "flex", width: "100%" }}>
  //               <DeviceLoadingGrid
  //                 CardCount={
  //                   20
  //                 }
  //               />
  //             </div>
  //           ) : (
  //             <>
  //             <div className={classes.searchContainer}>
  //             <SearchBar
  //                 type="text"
  //                 placeholder="Search..."
  //                 value={searchTerm}
  //                 onChange={(e) => setSearchTerm(e.target.value)}
  //                 style={{
                    
  //                     padding: "10px", // Adjust padding to reduce height
  //                     width: "300px",    // Set a specific width
  //                     fontSize: "14px",  // Adjust font size for better proportions
  //                     boxSizing: "border-box", // Ensure consistent sizing
  //                     borderRadius: "4px", // Add slight rounding for aesthetics
                      
  //                 }}
  //             />
  //             {searchTerm !== "" && <div>
  //                 <p>{filteredData.length} results</p>
  //             </div>}
  //           </div>

  //             <DevicesList
  //               devices={filteredData}
  //               filtering={""}
  //               hideControls={false}
  //               totalPages={totalPages}
  //               setTotalPages={setTotalPages}
  //               pageFetchedIndex={pageFetchedIndex}
  //               setPageFetchedIndex={setPageFetchedIndex}
  //               pageSize={filteredData.length}
  //               setPageSize={setPageSize}
  //               totalDevices={filteredData.length}
  //               setTotalDevices={setTotalDevices}
  //               groupMode={false}
  //               update={update}
  //               setUpdate={setUpdate}
  //               offlineOnly={false}
  //               isSortable={true}
  //               showMassSelect={true}
  //               showMassSettings={showMassSettings}
  //               setShowMassSettings={setShowMassSettings}
  //             />
  //             </>
              
  //           )}
  //         </div>
  //           </>
  //         )

          

  //       }}
  //     </Await>
  //   )
  // }


export default Controllers;